import { render, staticRenderFns } from "./DoctorConsultation.vue?vue&type=template&id=26b58af8&"
import script from "./DoctorConsultation.vue?vue&type=script&lang=js&"
export * from "./DoctorConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports